import { equal, or, readOnly } from '@ember/object/computed';
import { isBlank, isEmpty } from '@ember/utils';
import { Platform } from 'cio/utils/push/platforms';
import attr from 'ember-data/attr';
import Model from '@ember-data/model';
import { belongsTo } from 'ember-data/relationships';
import CustomerModel from './customer';

export enum PushSubscription {
  Enabled,
  Disabled,
  Unset,
}

export default class DeviceModel extends Model {
  @belongsTo('customer', { async: false, inverse: 'devices' }) customer!: CustomerModel;

  @attr('number') lastUsed!: number;
  @attr('string') lastStatus!: string;
  @attr() platform!: Platform;
  @attr() attributes!: Record<string, unknown>;

  @readOnly('attributes.app_version') appVersion!: string;
  @readOnly('attributes.device_model') deviceModel!: string;
  @readOnly('attributes.device_os') deviceOs!: string;
  @readOnly('attributes.device_locale') deviceLocale!: string;
  @readOnly('attributes.cio_sdk_version') cioSdkVersion!: string;
  @equal('attributes.push_enabled', 'true') hasPushEnabled!: boolean;
  @equal('lastStatus', 'bounced') isBounced!: boolean;
  @equal('lastStatus', 'suppressed') isSuppressed!: boolean;
  @or('isBounced', 'isSuppressed') isInDeliveryFailure!: boolean;

  get deviceLocaleCountryCode() {
    if (isEmpty(this.deviceLocale)) {
      return null;
    }
    let localeComponents = this.deviceLocale.split('-');
    return localeComponents.length === 2 ? localeComponents[1].toLowerCase() : null;
  }

  get pushSubscription() {
    let { push_enabled: pushSubscription } = this.attributes;
    let state = PushSubscription.Unset;
    if (!isBlank(pushSubscription)) {
      let isPushEnabled = false;
      if (typeof pushSubscription === 'string') {
        isPushEnabled = pushSubscription === 'true';
      } else {
        isPushEnabled = pushSubscription as boolean;
      }
      state = isPushEnabled ? PushSubscription.Enabled : PushSubscription.Disabled;
    }
    return state;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    device: DeviceModel;
  }
}
